import { useTranslation } from 'react-i18next';
import { Loader, Body, LoaderType, getStringUuid } from '@portal/ui-library';

import { PersonRoleEnum } from 'models/extension-generated';
import styles from './AddPartnerButton.module.scss';
import { useHealthInsuranceContext } from 'contexts/HealthInsuranceContext';
import { useWizardNavigation } from 'hooks/useWizardNavigation';
import { WizardRoutesEnum } from 'utils/actions';
import { useApplicationValidation } from 'hooks/useApplicationValidation';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import { Button } from '@mui/material';

export const AddPartnerButton = ({ onPersonSwitch }: { onPersonSwitch?: () => void }) => {
  const { t } = useTranslation('wizardPrivateHealthInsurance');
  const { reducer, selectPartner, state, partnerId } = useHealthInsuranceContext();
  const { isValidating, validatePartner } = useApplicationValidation(state, reducer, partnerId);
  const { goTo } = useWizardNavigation();
  const { createPartner } = reducer;

  const handleAddInsuredPerson = async () => {
    try {
      const validationResult = await validatePartner(partnerId);

      if (validationResult.size === 0) {
        const id = getStringUuid();

        createPartner({ role: PersonRoleEnum.INSURED_PERSON, id });
        selectPartner(id);
        goTo(WizardRoutesEnum.PrivateData);
        onPersonSwitch?.();
      } else {
        setTimeout(() => {
          const validationErrorButton = document.getElementById('validationErrorButton');
          if (validationErrorButton) {
            validationErrorButton.focus();
          }
        }, 500);
      }
    } catch {
      // TODO: handle error (TODO from agent-portal)
    }
  };
  if (isValidating) {
    return (
      <Button size="large" variant="text" disabled>
        <div className={styles.loadingButton}>
          <Body small medium className="mr-s">
            {t('actions.validating')}
          </Body>
          <Loader className={styles.loader} type={LoaderType.Circular} />
        </div>
      </Button>
    );
  }

  return (
    <div className="flex items-center gap-[8px]">
      <Button
        variant="outlined"
        size="large"
        aria-description={t('actions.addInsuredPersonDescription')}
        onClick={handleAddInsuredPerson}
        startIcon={<PersonAddAlt1OutlinedIcon />}
      >
        {t('actions.addInsuredPerson')}
      </Button>
    </div>
  );
};
